import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容分类',
    links: [
      { label: '法律合规', href: '/category/legal-compliance' },
      { label: '内容审核', href: '/category/content-review' },
      { label: '技术架构', href: '/category/tech-architecture' },
      { label: '运营策略', href: '/category/operation-strategy' },
      { label: '风险防控', href: '/category/risk-prevention' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '联系方式', href: '/about#contact' },
    ],
  },
  {
    title: '法律声明',
    links: [
      { label: '免责声明', href: '/about' },
      { label: '隐私政策', href: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-1">
              <Link to="/" className="flex items-center gap-2 text-lg font-bold whitespace-nowrap mb-3">
                <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
                  合规
                </span>
                <span className="font-heading">合规运营指南</span>
              </Link>
              <p className="text-foreground-400 text-sm leading-relaxed">
                专业的成人内容行业合规运营知识平台，致力于为从业者提供权威的法律指南、技术方案和运营策略。
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="font-semibold text-sm mb-4 text-background-50">
                  {group.title}
                </h4>
                <ul className="space-y-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.href}
                        className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800/50">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-foreground-500 text-xs">
                &copy; {new Date().getFullYear()} 合规运营指南. 本站内容仅供行业参考，不构成法律建议。
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors text-xs" rel="nofollow">
                  免责声明
                </a>
                <a href="#" className="text-foreground-500 hover:text-primary-400 transition-colors text-xs" rel="nofollow">
                  隐私政策
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}